export type Period = 'today' | '7d' | '30d' | 'month'

const PERIOD_LABELS: Record<Period, string> = {
  today: 'Today',
  '7d':  '7 days',
  '30d': '30 days',
  month: 'Month',
}

export default function PeriodFilter({ value, onChange }: { value: Period; onChange: (p: Period) => void }) {
  return (
    <div className="inline-flex bg-white/5 rounded-lg p-1 border border-white/10">
      {(Object.keys(PERIOD_LABELS) as Period[]).map(p => (
        <button
          key={p}
          onClick={() => onChange(p)}
          className={`px-3 py-1.5 rounded-md text-xs font-semibold transition ${
            value === p
              ? 'bg-[#C41E3A] text-white'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          {PERIOD_LABELS[p]}
        </button>
      ))}
    </div>
  )
}
